import React, { useState, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import useTranslation from 'hooks/useTranslation';

import {
  Box,
  ContainerBox,
  Footer,
  Header,
  PageTitle,
  TextArea,
} from 'components';

import useStyles from 'styles/roulette';
import { TwitterPicker } from 'react-color';

import { Button, Typography } from '@material-ui/core';
import { Form } from '@unform/web';

interface RouletteProps {
  textArea: string;
}

const tagManagerArgs = {
  dataLayer: {
    page: 'sorteio-de-roleta',
  },
  dataLayerName: 'PageDataLayer',
};

const Roulette: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [dataSort, setDataSort] = useState([]);
  const [mustSpin, setMustSpin] = useState(false);
  const [visibleColorOne, setVisibleColorOne] = useState(false);
  const [visibleColorTwo, setVisibleColorTwo] = useState(false);
  const [colorSpinnerOne, setColorSpinnerOne] = useState('#B391E3');
  const [colorSpinnerTwo, setColorSpinnerTwo] = useState('#884DE0');
  /* eslint-disable-next-line */
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const [winner, setWinner] = useState<any>();
  const [statusWinner, setStatusWinner] = useState(false);
  const [wheel, setWheel] = useState(<div />);

  const handleSpinClick = () => {
    setDisabled(true);
    setStatusWinner(false);
    const newPrizeNumber = Math.floor(Math.random() * dataSort.length);
    setPrizeNumber(newPrizeNumber);

    setTimeout(() => {
      setDisabled(false);
      setWinner(dataSort[newPrizeNumber]);
      setStatusWinner(true);
    }, 10000);

    setMustSpin(true);
  };

  async function handleFormSubmit(isData: RouletteProps) {
    const options: any = [];

    if (isData.textArea.length <= 0) {
      return;
    }

    const count = isData.textArea.split('\n');
    if (count.length <= 1) {
      return;
    }

    let n = 0;

    const names = isData.textArea.split('\n');
    names.map(async name => {
      const letColor: any = [];
      const calcul = n + 1;
      n = calcul;

      if (calcul % 2 === 0) {
        letColor.push(colorSpinnerOne);
      } else {
        letColor.push(colorSpinnerTwo);
      }
      setVisibleColorOne(false);
      setVisibleColorTwo(false);

      return options.push({
        option: name,
        style: {
          backgroundColor: `${letColor}`,
          textColor: 'white',
        },
      });
    });

    setDataSort(options);
  }

  const handleChangeCompleteOne = (color: any) => {
    setColorSpinnerOne(color.hex);
  };

  const handleChangeCompleteTwo = (color: any) => {
    setColorSpinnerTwo(color.hex);
  };

  useEffect(() => {
    TagManager.dataLayer(tagManagerArgs);
  }, []);

  useEffect(() => {
    import('react-custom-roulette').then(item => {
      const { Wheel } = item;
      setWheel(
        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={prizeNumber}
          data={dataSort}
          innerBorderWidth={20}
          innerBorderColor="white"
          outerBorderWidth={5}
          outerBorderColor="white"
          radiusLineWidth={5}
          radiusLineColor="white"
          textDistance={50}
          fontSize={15}
          onStopSpinning={() => {
            setMustSpin(false);
          }}
        />,
      );
    });
  }, [mustSpin, prizeNumber, dataSort]);

  return (
    <>
      <Header />
      <ContainerBox>
        <PageTitle title={t('roulette')} />
        <Box>
          <div className={classes.box}>
            <div></div>
            <Typography className={classes.title} variant="body2">
              {t('rouletteSettings')}
            </Typography>
            <div></div>
          </div>
          {statusWinner && (
            <div className={classes.winners}>
              {t('winner')} <b>{winner.option}</b>
            </div>
          )}
          <div className={classes.container}>
            {dataSort.length === 0 ? (
              <></>
            ) : (
              <div className={classes.rouletteStyles}>
                {wheel}
                <Button
                  className={classes.buttonSort}
                  onClick={() => handleSpinClick()}
                  endIcon=""
                  disabled={disabled}
                >
                  {t('holdDraw')}
                </Button>
              </div>
            )}
            <div className={classes.settings}>
              <Form onSubmit={handleFormSubmit} className={classes.form}>
                <div className={classes.titleBox}>
                  <Typography>{t('informNames')}</Typography>
                </div>
                <TextArea
                  draggable={false}
                  className={classes.containerTextArea}
                  name="textArea"
                  rows={12}
                />
                <div className={classes.titleBox}>
                  <Typography variant="body1">{t('chooseColours')}</Typography>
                </div>
                <div className={classes.boxColor}>
                  <div>
                    {visibleColorOne ? (
                      <Button
                        style={{ backgroundColor: `${colorSpinnerOne}` }}
                        endIcon=""
                        className={classes.buttonColor}
                        onClick={() => setVisibleColorOne(false)}
                      >
                        {t('save')}
                      </Button>
                    ) : (
                      <Button
                        style={{ backgroundColor: `${colorSpinnerOne}` }}
                        endIcon=""
                        className={classes.buttonColor}
                        onClick={() => setVisibleColorOne(true)}
                      >
                        {t('editColour')}
                      </Button>
                    )}
                  </div>
                  <div>
                    {visibleColorTwo ? (
                      <Button
                        style={{ backgroundColor: `${colorSpinnerTwo}` }}
                        endIcon=""
                        className={classes.buttonColor}
                        onClick={() => setVisibleColorTwo(false)}
                      >
                        {t('save')}
                      </Button>
                    ) : (
                      <Button
                        style={{ backgroundColor: `${colorSpinnerTwo}` }}
                        endIcon=""
                        className={classes.buttonColor}
                        onClick={() => setVisibleColorTwo(true)}
                      >
                        {t('editColour')}
                      </Button>
                    )}
                  </div>
                </div>
                {visibleColorOne ? (
                  <div className={classes.picker}>
                    <TwitterPicker onChangeComplete={handleChangeCompleteOne} />
                  </div>
                ) : (
                  <></>
                )}
                {visibleColorTwo ? (
                  <div className={classes.picker}>
                    <TwitterPicker onChangeComplete={handleChangeCompleteTwo} />
                  </div>
                ) : (
                  <></>
                )}
                <button className={classes.buttonSave} type="submit">
                  <Typography variant="body2">{t('saveSettings')}</Typography>
                </button>
              </Form>
            </div>
          </div>
        </Box>
      </ContainerBox>

      <Footer />
    </>
  );
};

export default Roulette;
